








import { Component, Vue, Prop, Mixins } from 'vue-property-decorator';
import { Actions } from '@/ts/store/Constants';
import MessageActionsWrapper from './MessageActionsWrapper.vue';
import ConversationData from '@/ts/ConversationData';
import NotifyMethods from '@/mixins/NotifyMethods.vue';

@Component({
    components: {
        MessageActionsWrapper,
    },
})
export default class AbuseConversationActions extends Mixins(NotifyMethods) {
    @Prop() public value: any;
    @Prop() public conversation: ConversationData;

    get show() {
        return this.value;
    }

    set show(value) {
        this.$emit('input', value);
    }

    public handleReport() {
        this.$store.dispatch(Actions.REPORT_CONTENT, {
            type: 'conversation',
            id: this.conversation.id,
        }).then(() => {
            this.notify('conversation_reported', 'positive');
        }).finally(() => {
            this.show = false;
        });
    }

    public handleBlock() {
        this.$store.dispatch(Actions.BLOCK_CONTENT, {
            type: 'user',
            id: this.conversation.authorId,
        }).then(() => {
            this.$router.back();
            this.notify('user_blocked', 'positive');
        }).finally(() => {
            this.show = false;
        });
    }

    public handleHide() {
        this.$store.dispatch(Actions.HIDE_CONTENT, {
            type: 'conversation',
            id: this.conversation.id,
        }).then(() => {
            this.$router.back();
            this.notify('conversation_hidden', 'positive');
        }).finally(() => {
            this.show = false;
        });
    }
}
